import { createEnv } from '@t3-oss/env-core';
import * as z from 'zod';

/**
 * Client-side env (build-time from Vite, import.meta.env)
 */
export const clientEnv = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_BASE_URL: z.url().default('http://localhost:3000'),

    // Public OAuth client identifier used by Google One Tap.
    VITE_GOOGLE_CLIENT_ID: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),

    // AI image generation: enable generation (false = coming soon)
    VITE_ENABLE_IMAGE_GENERATION: z
      .enum(['true', 'false', ''])
      .default('')
      .transform((v) => v === 'true'),

    // AI image generation: show provider selector in generate page
    VITE_SHOW_IMAGE_PROVIDER: z
      .enum(['true', 'false', ''])
      .default('')
      .transform((v) => v === 'true'),

    // Payment provider: 'stripe' | 'creem' | '' (empty = disabled)
    VITE_PAYMENT_PROVIDER: z.enum(['stripe', 'creem', '']).default(''),

    // Payment (Stripe) - Subscription Plans
    VITE_STRIPE_PRICE_STARTER_MONTHLY: z.string().optional(),
    VITE_STRIPE_PRICE_STARTER_YEARLY: z.string().optional(),
    VITE_STRIPE_PRICE_GROWTH_MONTHLY: z.string().optional(),
    VITE_STRIPE_PRICE_GROWTH_YEARLY: z.string().optional(),
    VITE_STRIPE_PRICE_PRO_MONTHLY: z.string().optional(),
    VITE_STRIPE_PRICE_PRO_YEARLY: z.string().optional(),
    VITE_STRIPE_PRICE_LIFETIME: z.string().optional(),
    // Optional; without it the $0.99 download uses an inline Stripe product.
    VITE_STRIPE_PRODUCT_DOWNLOAD: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),

    // Payment (Stripe) - Credit Packages (one-time purchases)
    VITE_STRIPE_PRICE_CREDIT_BASIC: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_STANDARD: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_PREMIUM: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_ENTERPRISE: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_CREATOR_PACK: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_CAMPAIGN_PACK: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_POPULAR_PACK: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_STUDIO_PACK: z.string().optional(),
    VITE_STRIPE_PRICE_CREDIT_SCALE_PACK: z.string().optional(),
    VITE_STRIPE_PRICE_STARTER_DROP: z.string().optional(),
    VITE_STRIPE_PRICE_CREATOR_STACK: z.string().optional(),
    VITE_STRIPE_PRICE_STUDIO_VAULT: z.string().optional(),

    // Payment (Creem)
    VITE_CREEM_PRODUCT_PRO_MONTHLY: z.string().optional(),
    VITE_CREEM_PRODUCT_PRO_YEARLY: z.string().optional(),
    VITE_CREEM_PRODUCT_LIFETIME: z.string().optional(),

    // Analytics
    VITE_GOOGLE_ANALYTICS_ID: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_GOOGLE_ADS_ID: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_GOOGLE_ADS_PURCHASE_CONVERSION_LABEL: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_GOOGLE_ADS_SIGNUP_CONVERSION_LABEL: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_GOOGLE_ADS_BEGIN_CHECKOUT_CONVERSION_LABEL: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_GOOGLE_ADS_FIRST_GENERATION_CONVERSION_LABEL: z.preprocess(
      (value) => (value === '' ? undefined : value),
      z.string().optional()
    ),
    VITE_CLARITY_PROJECT_ID: z.string().optional(),
    VITE_PLAUSIBLE_SCRIPT: z.string().optional(),
    VITE_UMAMI_WEBSITE_ID: z.string().optional(),
    VITE_UMAMI_SCRIPT: z.string().optional(),

    // Chatbot (Crisp Chat)
    VITE_CRISP_WEBSITE_ID: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
});
